module.exports = __webpack_public_path__ + "resources/img/img_docuone4.86213471d2a8fd61f0bde46d4b27cef2.png";